module.exports = __webpack_public_path__ + "img/identifai-2.535253a1.jpeg";